import { api1C } from './api';

export const setSettings = (data, params) => 
    api1C.post('settings', data, { params });